<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item>
            <el-cascader
              ref="regionCascader"
              :options="regionData"
              :props="regionProps"
              v-model="checkedRegionData"
              placeholder="省市县"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item prop="cooperativeName">
            <el-input
              v-model="filterForm.cooperativeName"
              placeholder="经营主体名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="liainsonNameOrCorName">
            <el-input
              v-model="filterForm.liainsonNameOrCorName"
              placeholder="法定代表人/联系人"
            ></el-input>
          </el-form-item>
          <el-form-item prop="loginMobile">
            <el-input
              v-model="filterForm.loginMobile"
              placeholder="注册手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="applyStatus">
            <el-select v-model="filterForm.applyStatus" placeholder="状态">
              <el-option label="全部" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.code"
                :key="item.code"
                v-for="item in uniqeGlobalDict$$['1']"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <el-table
        :data="tableData"
        @sort-change="timeSortChange"
        style="width: 100%; margin-top: 10px"
      >
        <el-table-column label="序号" min-width="5%" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="location"
          label="所在地"
          min-width="20%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cooperativeName"
          label="经营主体名称"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="corName"
          label="法定代表人"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="liaisonName"
          label="联系人"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="loginMobile"
          label="注册手机号"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="applyTime"
          sortable
          label="注册申请时间"
          min-width="12%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="applyStatus"
          label="注册申请状态"
          min-width="10%"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" min-width="12%" align="center">
          <div slot-scope="{ row }" style="text-align: left">
            <el-button
              type="primary"
              plain
              round
              size="mini"
              @click="toDetail(row.id)"
              >查看</el-button
            >
            <el-button
              v-if="row.applyStatus == '待审核'"
              type="primary"
              plain
              round
              size="mini"
              @click="toExamine(row.id)"
              >审核</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.size"
        :total="pagination.total"
        :hide-on-single-page="true"
        :current-page.sync="pagination.page"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
import regionLibs from "utils/regionSeatLibs";
import {
  getSessionStorageQuery,
  setSessionStorageQuery,
} from "@/utils/common.js";
let regionData = JSON.parse(JSON.stringify(regionLibs[0].c));
export default {
  name: "CooperativeApplyList",
  $dictKeyList: [
    {
      key: "1",
      name: "状态",
    },
  ],
  data() {
    return {
      filterForm: {
        provinceId: "",
        cityId: "",
        areaId: "",
        cooperativeName: "",
        liainsonNameOrCorName: "",
        loginMobile: "",
        applyStatus: "",
        ascOrDesc: "3", //排序  2：升序  3：降序
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      tableData: [],

      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
        checkStrictly: this.dataSource == 2 ? false : true,
      },
      regionData,
      dicts: {
        applyStatus: [],
      },
    };
  },
  props: {
    dataSource: {
      type: Number,
    },
  },
  filters: {},
  watch: {
    checkedRegionData(newVal) {
      this.filterForm.provinceId = newVal[0] || "";
      this.filterForm.cityId = newVal[1] || "";
      this.filterForm.areaId = newVal[2] || "";
    },
  },
  created() {},
  mounted() {
    this.setCacheData();
    this.getCooperativeList();
  },
  methods: {
    // 设置缓存过的数据 比如查询条件 和 tab
    setCacheData() {
      const cache = getSessionStorageQuery();
      if (!cache || cache.activeName !== "2") return;
      this.filterForm = cache.filterForm;
      this.pagination = cache.pagination;
      const { provinceId, cityId, areaId } = cache.filterForm;
      this.dataSource = cache.dataSource;
      this.checkedRegionData = [provinceId, cityId, areaId];
    },

    timeSortChange(val) {
      switch (val.order) {
        case "ascending":
          this.filterForm.ascOrDesc = "2";
          break;
        case "descending":
          this.filterForm.ascOrDesc = "3";
          break;
      }
      this.handleFilter();
    },
    // 查询
    handleFilter() {
      this.pagination.page = 1;
      this.getCooperativeList();
    },
    //获取列表数据
    getCooperativeList() {
      let params = Object.assign({}, this.filterForm, {
        dataSource: this.dataSource,
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.cooperative.applyExamineListFilter(params).then((res) => {
        this.tableData = res.data.content;
        if (this.pagination.page == 1)
          this.pagination.total = res.data.recordTotal;
      });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedRegionData = [];
      this.checkedZone = [];
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getCooperativeList();
    },
    // 查看
    toDetail(id) {
      this.$router.push({
        path: "/cooperative/apply-examine/detail",
        query: { cooApplyId: id, dataSource: this.dataSource },
      });
    },
    // 审核
    toExamine(id) {
      setSessionStorageQuery({
        filterForm: this.filterForm,
        pagination: this.pagination,
        dataSource: this.dataSource,
        activeName: "2",
      });
      let params = Object.assign({}, this.filterForm, {
        dataSource: this.dataSource,
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$router.push({
        path: "/cooperative/apply-examine/examine",
        query: { cooApplyId: id, dataSource: this.dataSource },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
